import React from 'react';
import classNames from 'classnames';

import { FormattedMessage, useIntl } from '../../../util/reactIntl';

import { IconAlert, Modal, Button } from '../../../components';

import css from './DiscardDraftModal.module.css';

/**
 * Dispute modal
 *
 * @param {Object} props
 * @param {string} [props.className] - Custom class that extends the default class for the root element
 * @param {string} [props.rootClassName] - Custom class that overrides the default class for the root element
 * @param {string} props.id - The id of the modal
 * @param {boolean} props.isOpen - Whether the modal is open
 * @param {function} props.onCloseModal - The function to close the modal
 * @param {function} props.onManageDisableScrolling - The function to manage disable scrolling
 * @param {function} props.onDiscardDraft - The function to discard the draft
 * @param {number} [props.discardCount] - How many drafts will be discarded
 * @param {string} [props.scrollLayerClassName] - Extra class for the dimmed overlay
 * @returns {JSX.Element} Discard draft modal component
 */
const DiscardDraftModal = props => {
  const intl = useIntl();
  const {
    className,
    rootClassName,
    id,
    isOpen,
    focusElementId,
    onCloseModal,
    onManageDisableScrolling,
    onDiscardDraft,
    discardCount = 1,
    scrollLayerClassName,
  } = props;
  const classes = classNames(rootClassName || css.root, className);
  const isMultiple = discardCount > 1;

  return (
    <Modal
      id={id}
      containerClassName={classes}
      contentClassName={css.modalContent}
      isOpen={isOpen}
      onClose={onCloseModal}
      onManageDisableScrolling={onManageDisableScrolling}
      focusElementId={focusElementId}
      usePortal
      scrollLayerClassName={classNames(css.scrollLayer, scrollLayerClassName)}
      closeButtonMessage={intl.formatMessage({ id: 'DiscardDraftModal.close' })}
    >
      <IconAlert className={css.modalIcon} />
      <p className={css.modalTitle}>
        <FormattedMessage
          id={isMultiple ? 'DiscardDraftModal.titleMultiple' : 'DiscardDraftModal.title'}
          values={{ n: discardCount }}
        />
      </p>
      <p className={css.modalMessage}>
        <FormattedMessage id="DiscardDraftModal.message" />
      </p>
      <Button onClick={onDiscardDraft} className={css.submitButton}>
        <FormattedMessage
          id={isMultiple ? 'DiscardDraftModal.submitMultiple' : 'DiscardDraftModal.submit'}
        />
      </Button>
    </Modal>
  );
};

export default DiscardDraftModal;
